

import clientAPI from "@/api/ClientAPIMixin.js";
//import Vue from "vue"



export const JobCustomer = {
  namespaced: true,

  state: {
    //lists
    CustomerAdresses: null,
    CustomerContacts: null,

    //objects
    Customer: null,
    CustomerLoading: false,
    CustomerDeliveryAdress: null,
    CustomerContact: null,
  },

  mutations: {
    //lists
    SET_CUSTOMER_ADRESSES(state, newcustomeradresses) {
      state.CustomerAdresses = newcustomeradresses;
    },
    SET_CUSTOMER_CONTACTS(state, newcustomercontacts) {
      state.CustomerContacts = newcustomercontacts;
    },

    //objects
    SET_CUSTOMER(state, newcustomer) {
      state.Customer = newcustomer;
    },
    SET_CUSTOMER_DELIVERY_ADRESS(state, newcustomerdeliveryadress) {
      state.CustomerDeliveryAdress = newcustomerdeliveryadress;
    },
    SET_CUSTOMER_CONTACT(state, newcustomercontact) {
      state.CustomerContact = newcustomercontact;
    },
  },

  actions: {

    /**============================================
     *?ANCHOR               CONTACT LIST
     *=============================================**/
    setCustomerContacts({ commit }, newcustomercontacts) {
      commit("SET_CUSTOMER_CONTACTS", newcustomercontacts);
      if (newcustomercontacts.length > 0) {
        commit("SET_CUSTOMER_CONTACT", newcustomercontacts[0]);
      }
      else {
        commit("SET_CUSTOMER_CONTACT", null);
      }
    },

    getCustomerContacts({ dispatch }, id) {
      clientAPI.methods.getCustomerContactsByCustomerId(id)
        .then((response) => {
          dispatch('setCustomerContacts', response);
        })

    },

    /**============================================
     *?ANCHOR               ADDRESS LIST
     *=============================================**/
    setCustomerAdresses({ commit }, newcustomeradresses) {
      commit("SET_CUSTOMER_ADRESSES", newcustomeradresses);
    },

    getCustomerAdresses({ dispatch }, id) {
      clientAPI.methods.getCustomerAdressesByCustomerId(id)
        .then((response) => {
          dispatch('setCustomerAdresses', response);
        })

    },

    /**============================================
     *?ANCHOR               CUSTOMER
     *=============================================**/
    async setCustomer({ commit }, newcustomer) {
      commit("SET_CUSTOMER", newcustomer);
    },

    getCustomer({ dispatch, state }, id) {
      state.CustomerLoading = true;
      clientAPI.methods.getCustomerById(id)
        .then((response) => {
          dispatch('setCustomer', response);
          dispatch('setCustomerContact', response.DefaultCustomerPerson);
        })
        .finally(() => state.CustomerLoading = false);

    },

    /**============================================
     *?ANCHOR               ADDRESS
     *=============================================**/
    setDeliveryAdress({ commit }, newcustomerdeliveryadress) {
      commit("SET_CUSTOMER_DELIVERY_ADRESS", newcustomerdeliveryadress);
    },

    async swapDeliveryAdress({ commit, state, rootGetters }, customerdeliveryadress) {
      const jobId = rootGetters['JobHub/JobParentjob/JobDetails'].Id;
      var idsAreDifferent = !state.CustomerDeliveryAdress || !customerdeliveryadress || !(state.CustomerDeliveryAdress.Id === customerdeliveryadress.Id)
      if (idsAreDifferent) { //if different ids swawp with new and give feedback
        await clientAPI.methods.swapCustomerAdress(jobId, customerdeliveryadress.Id)
        commit("SET_CUSTOMER_DELIVERY_ADRESS", customerdeliveryadress);
      }
      else { //else use swap to update archived value silently
        await clientAPI.methods.swapCustomerAdress(jobId, customerdeliveryadress.Id, true)
        commit("SET_CUSTOMER_DELIVERY_ADRESS", customerdeliveryadress);
      }
    },

    getCustomerDeliveryAdress({ dispatch }, ids) {
      clientAPI.methods.getCustomerAdressById(ids)
        .then((response) => {
          dispatch('setDeliveryAdress', response);
        })

    },

    /**============================================
     *?ANCHOR               CONTACT
     *=============================================**/
    setCustomerContact({ commit }, newcustomercontact) {
      commit("SET_CUSTOMER_CONTACT", newcustomercontact);
    },

    swapCustomerContact({ commit, rootGetters }, newcustomercontact) {
      const jobId = rootGetters['JobHub/JobParentjob/JobDetails'].Id;
      clientAPI.methods.swapCustomerContact(jobId, newcustomercontact.Id)
      commit("SET_CUSTOMER_CONTACT", newcustomercontact);
    },

    getCustomerContact({ dispatch }, id) {
      clientAPI.methods.getCustomerContactById(id)
        .then((response) => {
          dispatch('setCustomerContact', response);
        })

    },
  },



  getters: {
    //lists
    CustomerAdresses: state => {
      return state.CustomerAdresses;
    },
    CustomerContacts: state => {
      return state.CustomerContacts;
    },

    //objects
    Customer: state => {
      return state.Customer;
    },
    CustomerLoading: state => {
      return state.CustomerLoading;
    },
    CustomerDeliveryAdress: (state, getters, rootState, rootGetters) => {
      return state.CustomerDeliveryAdress //if set use that
        ?? rootGetters['JobHub/JobSubjobs/MachineDeliveryAddressCandidate'] // else if machine has delivery address use that
        ?? getters.Customer?.DefaultDeliveryAddress; // else use customer default delivery address
    },
    CustomerContact: state => {
      return state.CustomerContact;
    },
  },

};
